import { observer } from 'mobx-react';
import * as React from 'react';
import withRouter from '../../hocs/WithRouter';
import { PhoneNumProps } from './interfaces';

class PhoneNumbersPopup extends React.Component<PhoneNumProps> {
  makeCall = (phoneNumber: number) => (e) => {
    const { callWithPerson } = this.props;
    e.stopPropagation();
    void callWithPerson(null, phoneNumber.toString());
  };

  handleOpenChat = (phoneNumber: number) => async (e) => {
    e.stopPropagation();
    const resp = await this.props.loadOrCreateConversationWithPost(
      null,
      phoneNumber.toString()
    );
    this.props.navigate(`/chat/conversations/${resp.data.id}/menu`);
  };

  render() {
    const { phoneNumbers, operationType, classNames } = this.props;
    return (
      <div className={`phonenum-popup ${classNames}`}>
        {phoneNumbers?.map((phone) =>
          phone.number ? (
            <div
              key={phone.number + phone.type}
              onClick={
                operationType === 'call'
                  ? this.makeCall(phone.number)
                  : this.handleOpenChat(phone.number)
              }
            >
              {phone.type.charAt(0).toUpperCase() + phone.type.slice(1)}:{' '}
              {phone.number}
            </div>
          ) : (
            <div
              key={phone}
              onClick={
                operationType === 'call'
                  ? this.makeCall(phone)
                  : this.handleOpenChat(phone)
              }
            >
              {phone}
            </div>
          )
        )}
      </div>
    );
  }
}
export default withRouter(observer(PhoneNumbersPopup));
